import React from "react";
import { PlusIcon } from "@heroicons/react/20/solid";

export type ButtonAddProps = {
  functionButton: () => void;
};

const ButtonAdd: React.FC<ButtonAddProps> = ({ functionButton }) => {
  return (
    <button
      onClick={functionButton}
      type="button"
      className="block rounded-full border-2 border-dashed border-gray-400 p-2 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
      aria-label="Add"
    >
      <PlusIcon aria-hidden="true" className="h-5 w-5" />
    </button>
  );
};

export default ButtonAdd;
